import { FormHelperText } from "@chakra-ui/react";
import { FunctionComponent } from "react";



interface FieldErrorProps {
    error: any
}
 
const FieldError: FunctionComponent<FieldErrorProps> = ({ error }) => {
    if(!error) {
        return null
    }

    return <FormHelperText color={'red.300'}>{error?.message}</FormHelperText>
}
 
export default FieldError;